import makeConstants from 'lib/makeConstants';
/**
 * The `EVENTS` object is used to standardize the analytics events
 * we emit thorough out the application. The intent is to allow us to trigger
 * a single standardized event (with metadata) that can be consumed by multiple
 * registered analytics "listeners" for passing to various thrid-parties.
 *
 * @name EVENTS
 * @type {Object}
 * @namespace Analytics
 */
export default makeConstants(
  /**
   * @description An event emitted when the analytics service is started.
   */
  'START',
  /**
   * @description An event to be emitted when a page view occurs.
   */
  'PAGEVIEW',
  /**
   * @description An event to be emitted when classroom invitations are sent out.
   */
  'CLASSROOM_INVITE',
  /**
   * @description An event to be emitted when a new classroom is created.
   */
  'CLASSROOM_CREATED',
  /**
   * @description An event to be emitted when a subject is purchased (checkout).
   */
  'SUBJECT_PURCHASE',
  /**
   * @description An event to be emitted when a user sign up occurs.
   */
  'USER_SIGN_UP',
  /**
   * @description An event to be emitted when a user sign in occurs.
   */
  'USER_SIGN_IN',
  /**
   * @description An event to be emitted when a valid user session starts.
   */
  'USER_SESSION_START',
  /**
   * @description An event to be emitted when a user session ends.
   */
  'USER_SESSION_END',
  /**
   * @description An event to be emitted when an assignment is created.
   */
  'ASSIGNMENT_CREATED',
  /**
   * @description An event to be emitted when an assignment is assigned.
   */
  'ASSIGNMENT_ASSIGNED',
  /**
   * @description An event to be emitted when a teacher creates a folder.
   */
  'FOLDER_CREATED'
);
